/**
 * Подсветка одного объекта на холсте SVG-фильтром (`HoverTints`): тот, что под курсором.
 *
 * Фильтр ставим в ближайшем кадре анимации, а не прямо в обработчике движения мыши:
 * поставленный в том же кадре, что и перерисовка холста, Chrome не рисует до следующего
 * изменения корневого SVG — объект под курсором оставался бы без подсветки.
 * Стал `active` ложным (сменили инструмент, отпустили стрелку) — подсветка снимается.
 */
import { useEffect, useRef } from "react";

export const useHoverTint = (filterId: string, active: boolean) => {
	/** Объект, который надо подсветить */
	const hovered = useRef<SVGElement | null>(null);
	/** Объект, на котором подсветка нарисована сейчас */
	const tinted = useRef<SVGElement | null>(null);
	const frame = useRef(0);

	/** Подсветить `element`; null — снять подсветку. */
	const setHovered = (element: SVGElement | null) => {
		if (element === hovered.current) return;
		hovered.current = element;
		cancelAnimationFrame(frame.current);
		frame.current = requestAnimationFrame(() => {
			if (tinted.current === hovered.current) return;
			if (tinted.current) tinted.current.style.filter = "";
			tinted.current = hovered.current;
			if (tinted.current) tinted.current.style.filter = `url(#${filterId})`;
		});
	};

	// Подсветка выключена или холст ушёл со страницы — фильтр не должен остаться на объекте
	useEffect(() => {
		if (active) return;
		cancelAnimationFrame(frame.current);
		if (tinted.current) tinted.current.style.filter = "";
		tinted.current = null;
		hovered.current = null;
	}, [active]);
	useEffect(
		() => () => {
			cancelAnimationFrame(frame.current);
			if (tinted.current) tinted.current.style.filter = "";
		},
		[],
	);

	return { setHovered };
};
